import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { ObsFechaNueva } from '@/app/models/interface/obs-fecha-nueva.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class ObsFechaNuevaService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'obs-fecha-nueva/';

  create(data: Partial<ObsFechaNueva>) {
    return this.http.post<CustomResponse<ObsFechaNueva>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
